/**
 *
 *  TrainerRating
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 23/02/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
import { shape, string, number, func } from "prop-types";

// Icons
import StarFullIcon from "../../icons/StarFullIcon";
import StarHalfIcon from "../../icons/StarHalfIcon";

export const TrainerRating = ({
  partner,
  className,
  averageRatingClassName,
  numberOfSessionsClassName,
  ratingsText = "Ratings",
  fractionDigits = 2,
  onClick,
}) => {
  const { partnerRatingRecap } = partner;
  const partnerAverageRating = partnerRatingRecap.average;
  const partnerNumberOfRatings = partnerRatingRecap.numberOfRatings;

  return (
    <div
      className={`${className} tbk-flex tbk-items-center`}
      itemScope
      itemProp="aggregateRating"
      itemType="http://schema.org/AggregateRating"
      title={`${partnerAverageRating.toFixed(
        fractionDigits
      )} out of 5 stars from ${partnerNumberOfRatings} ratings`}
      aria-label={`${partnerAverageRating} out of 5 stars from ${partnerNumberOfRatings} ratings`}
    >
      <span className="tbk-text-coral">
        {partnerAverageRating === 5 ? <StarFullIcon /> : <StarHalfIcon />}
      </span>
      <span
        className={`${averageRatingClassName}${
          partnerNumberOfRatings > 0 ? " tbk-mr-2" : ""
        }`}
      >
        {partnerAverageRating.toFixed(fractionDigits)}
      </span>
      {partnerNumberOfRatings > 0 ? (
        <span
          role="button"
          className={`${numberOfSessionsClassName} tbk-whitespace-nowrap`}
          onClick={onClick}
        >
          {partnerNumberOfRatings} {ratingsText}
        </span>
      ) : null}
      <meta itemProp="ratingValue" content={partnerAverageRating} />
      <meta itemProp="bestRating" content="5" />
      <meta itemProp="ratingCount" content={partnerNumberOfRatings} />
    </div>
  );
};

TrainerRating.propTypes = {
  className: string,
  averageRatingClassName: string,
  numberOfSessionsClassName: string,
  partner: shape({
    partnerRatingRecap: shape({
      average: number.isRequired,
      numberOfRatings: number.isRequired,
    }),
  }).isRequired,
  onClick: func,
};

export default TrainerRating;
